class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure_element'),
    };
    if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    this.restoreCurrencySelection();
  }

  setCurrencySelection(currency, label, flag) {
    const currencyLabel = this.querySelector('[data-active-currency]');
    const flagElement = this.querySelector('[data-active-flag]');
    if (!currencyLabel || !flagElement || !currency || !label || !flag) return;

    currencyLabel.textContent = label;
    flagElement.className = `ivs-currency-flag ivs-flag--${flag}`;
    this.querySelectorAll('[data-currency]').forEach(item => {
      const isActive = item.dataset.currency === currency;
      item.classList.toggle('link-active', isActive);
      if (isActive) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  restoreCurrencySelection() {
    if (!this.querySelector('[data-currency]')) return;
    const savedCurrency = window.IVSouqCurrency?.getSelectedCurrency?.();
    const selectedOption =
      this.querySelector(`[data-currency="${savedCurrency}"]`) ||
      this.querySelector('[data-currency][aria-current="true"]') ||
      this.querySelector('[data-currency="AED"]');
    const currency = selectedOption?.dataset.currency;
    const label = selectedOption?.dataset.label;
    const flag = selectedOption?.dataset.flag;
    if (currency && label && flag) this.setCurrencySelection(currency, label, flag);
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const currency = target.dataset.currency;
    const label = target.dataset.label;
    const flag = target.dataset.flag;
    const value = target.dataset.value;
    const form = this.querySelector('form');

    if (currency && label && flag) {
      this.setCurrencySelection(currency, label, flag);
      this.elements.input.value = value || this.elements.input.value;
      window.IVSouqCurrency?.setCurrency(currency);
      document.querySelectorAll('localization-form').forEach(form => form.restoreCurrencySelection?.());
      if (form && value) {
        this.updateReturnUrl(value);
        form.submit();
        return;
      }
      this.hidePanel();
      return;
    }

    this.elements.input.value = value;
    if (form) {
      this.updateReturnUrl(value);
      form.submit();
    }
  }

  updateReturnUrl(countryCode) {
    const returnToInput = this.querySelector('input[name="return_to"]');
    if (!returnToInput || !countryCode) return;

    const marketPrefixes = {
      AE: '/en-ae',
      PK: '/en-pk',
      SA: '/en-sa',
      US: '',
    };
    const targetPrefix = marketPrefixes[countryCode];
    if (typeof targetPrefix === 'undefined') return;

    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const basePath = currentPath.replace(/^\/en-(ae|pk|sa)(?=\/|$)/, '') || '/';
    const localizedPath = `${targetPrefix}${basePath === '/' ? '' : basePath}` || '/';

    returnToInput.value = `${localizedPath}${window.location.search}`;
  }

  openSelector() {
    this.elements.button.focus();
    const isOpening = this.elements.panel.hasAttribute('hidden');
    document.querySelectorAll('localization-form .disclosure_element:not([hidden])').forEach(panel => {
      if (panel !== this.elements.panel) {
        panel.setAttribute('hidden', true);
        panel.closest('localization-form')?.querySelector('button')?.setAttribute('aria-expanded', 'false');
      }
    });
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', isOpening.toString());
  }

  closeSelector(event) {
    if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

window.IVSouqCurrency = window.IVSouqCurrency || (() => {
  const storageKey = 'ivsouq_selected_currency';
  const currencies = {
    AED: { code: 'AED', rate: 1, decimals: 2 },
    SAR: { code: 'SAR', rate: 1.022, decimals: 2 },
    PKR: { code: 'PKR', rate: 76.75, decimals: 0 },
    USD: { code: 'USD', rate: 0.2723, decimals: 2 },
  };

  const getSelectedCurrency = () => {
    const saved = localStorage.getItem(storageKey);
    return currencies[saved] ? saved : 'AED';
  };

  let isUpdating = false;

  const formatAmount = (baseCents, currencyCode) => {
    const currency = currencies[currencyCode] || currencies.AED;
    const baseAmount = (Number(baseCents) || 0) / 100;
    const convertedAmount = baseAmount * currency.rate;
    const amount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: currency.decimals,
      maximumFractionDigits: currency.decimals,
    }).format(convertedAmount);
    return `${amount} ${currency.code}`;
  };

  const updateMoneyElements = (currencyCode = getSelectedCurrency()) => {
    isUpdating = true;
    document.documentElement.dataset.ivsCurrency = currencyCode;
    document.querySelectorAll('[data-ivs-currency-code]').forEach(element => {
      element.textContent = currencyCode;
    });
    document.querySelectorAll('[data-ivs-money][data-ivs-base-cents]').forEach(element => {
      const prefix = element.dataset.ivsMoneyPrefix || '';
      const suffix = element.dataset.ivsMoneySuffix || '';
      element.textContent = `${prefix}${formatAmount(element.dataset.ivsBaseCents, currencyCode)}${suffix}`;
    });
    setTimeout(() => { isUpdating = false; }, 0);
  };

  const setCurrency = currencyCode => {
    if (!currencies[currencyCode]) return;
    localStorage.setItem(storageKey, currencyCode);
    updateMoneyElements(currencyCode);
  };

  let observerTimeout;
  const observePriceChanges = () => {
    const target = document.querySelector('#MainContent') || document.body;
    if (!target || !window.MutationObserver) return;
    new MutationObserver(() => {
      if (isUpdating) return;
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(() => updateMoneyElements(), 80);
    }).observe(target, { childList: true, subtree: true });
  };

  return { currencies, getSelectedCurrency, setCurrency, updateMoneyElements, observePriceChanges };
})();

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

document.addEventListener('DOMContentLoaded', () => {
  window.IVSouqCurrency.updateMoneyElements();
  window.IVSouqCurrency.observePriceChanges();
  document.querySelectorAll('localization-form').forEach(form => form.restoreCurrencySelection?.());
});
